<script>
import Details from '../../../share/payment/Details'
export default {
  mixins: [
    Details
  ]
}
</script>
